const getEnvLabel = () => {
  const nodeEnv = (import.meta.env.VITE_ENV || "").toLowerCase().trim();

  if (nodeEnv === "local") {
    return "LOCAL";
  }
  if (nodeEnv === "dev") {
    return "DEV";
  }
  if (nodeEnv === "qat") {
    return "QAT";
  }
  if (nodeEnv === "qa" || nodeEnv === "staging") {
    return "STAGE";
  }

  return "";
};

export const nodeEnv = (import.meta.env.VITE_ENV || "").toLowerCase().trim();

// Only show the nav env badge during local Vite dev (`npm run dev`).
export const current_env = getEnvLabel()

export const API_BASE = import.meta.env.VITE_URL;
export const LOGIN_URL = import.meta.env.VITE_MY_ID_START_SSO_URL;

export const ENDPOINTS_KEYS = {
  login: LOGIN_URL,
};

export const LOCAL_STORAGE_KEYS = {
  main: "cp-tap-ui",
  activeUser: "userId",
  token: "access-token",
  activeUserRole: "roles",
};

/**
 * Get RightsLine URL based on environment.
 * @param {"deal"|"catalog"|"contact"} type - mod4 deals, mod1 catalog, mod2 contacts
 */
export const RIGHTSLINE_URL = (type) => {
  const env = (import.meta.env.VITE_ENV || "").toUpperCase();
  const baseUrls = {
    deal: {
      "": "https://app.rightsline.com/mod4/",
      PROD: "https://app.rightsline.com/mod4/",
      QA: "https://app-staging.rightsline.com/mod4/",
      QAT: "https://app-pm.rightsline.com/mod4/",
      DEV: "https://app-int.rightsline.com/mod4/",
      LOCAL: "https://app-int.rightsline.com/mod4/",
    },
    catalog: {
      "": "https://app.rightsline.com/mod1/",
      PROD: "https://app.rightsline.com/mod1/",
      QA: "https://app-staging.rightsline.com/mod1/",
      QAT: "https://app-pm.rightsline.com/mod1/",
      DEV: "https://app-int.rightsline.com/mod1/",
      LOCAL: "https://app-int.rightsline.com/mod1/",
    },
    contact: {
      "": "https://app.rightsline.com/mod2/",
      PROD: "https://app.rightsline.com/mod2/",
      QA: "https://app-staging.rightsline.com/mod2/",
      QAT: "https://app-pm.rightsline.com/mod2/",
      DEV: "https://app-int.rightsline.com/mod2/",
      LOCAL: "https://app-int.rightsline.com/mod2/",
    },
  };
  return baseUrls[type][env] || baseUrls[type][""];
};

/**
 * Get PMX (Salesforce Lightning) deep link URL for a Release record.
 */
export const PMX_RELEASE_URL = (salesforceId) => {
  const env = (import.meta.env.VITE_ENV || "").toUpperCase();
  const baseUrls = {
    "": "https://pmx.lightning.force.com",
    PROD: "https://pmx.lightning.force.com",
    QA: "https://pmx--uat01.sandbox.lightning.force.com",
    QAT: "https://pmx--uat01.sandbox.lightning.force.com",
    DEV: "https://pmx--uat01.sandbox.lightning.force.com",
    LOCAL: "https://pmx--uat01.sandbox.lightning.force.com",
  };
  const base = baseUrls[env] || baseUrls[""];
  return `${base}/lightning/r/Release__c/${salesforceId}/view`;
};

// AG-Grid license key - should be set via environment variable VITE_AG_GRID_LICENSE_KEY
export const LICENSE_KEY = import.meta.env.VITE_AG_GRID_LICENSE_KEY || "";
